// Converts a string to a hashed 32bit integer, similar to javas hashCode
// These numbers can end up being negative when they overflow, this is expected
export function hashCode(currentString: string): number {
  let h = 0
  for (let i = 0; i < currentString.length; i++) {
    h = (Math.imul(31, h) + currentString.charCodeAt(i)) | 0
  }
  return h
}
